// extracted by mini-css-extract-plugin
export var background = "BehavioralData-module--background--3c44b";
export var behavioralDataSvg = "BehavioralData-module--behavioral-data-svg--b5a72";
export var content = "BehavioralData-module--content--dd2cf";
export var copy = "BehavioralData-module--copy--f7ef1";
export var desktop = "BehavioralData-module--desktop--72c3f";
export var empty = "BehavioralData-module--empty--de3e3";
export var full = "BehavioralData-module--full--4047f";
export var grid = "BehavioralData-module--grid--7edab";
export var image = "BehavioralData-module--image--5dfe0";
export var integrationsDefaults = "BehavioralData-module--integrations-defaults--f5dc7";
export var integrationsSvg = "BehavioralData-module--integrations-svg--1a7df";
export var mobile = "BehavioralData-module--mobile--5b339";
export var mobileCard = "BehavioralData-module--mobile-card--335fd";
export var popOut = "BehavioralData-module--pop-out--564fd";
export var progress = "BehavioralData-module--progress--7ddf9";
export var progressBars = "BehavioralData-module--progress-bars--89292";
export var section = "BehavioralData-module--section--fd28b";
export var sentiments = "BehavioralData-module--sentiments--d092b";
export var sessionReplaySvg = "BehavioralData-module--session-replay-svg--2b755";
export var stepsActive = "BehavioralData-module--steps-active--5c9c3";